{
  "error": {
    "userNotFound": "Користувача не існує. Будь ласка, зверніться до адміністратора."
  },
  "validation": {
    "required": "Обов'язкове поле",
    "incorrectPassword": "Неправильне ім'я користувача або пароль.",
    "emailNotVerified": "Пошту не підтверджено. Перевірте поштову скриньку.",
    "email": {
      "invalidFormat": "Неправильний формат"
    },
    "password": {
      "minLength": "Пароль повинен складати принаймні 8 символів"
    }
  },

  "form": {
    "title": "Увійти за допомогою електронної пошти",
    "email": {
      "label": "Електронна пошта",
      "placeholder": "maill@mail.zz"
    },
    "password": {
      "label": "Пароль",
      "placeholder": "Ваш пароль",
      "message": "Мінімум 8 символів, одна велика і одна мала літера"
    },
    "actions": {
      "submit": {
        "label": "Продовжити",
        "loading": "Завантаження"
      }
    },
    "googleButton": "Увійти з Google",
    "facebookButton": "Увійти з Facebook",
    "orSeparator": "Aбо",
    "forgotLink": "Забули пароль?"
  }
}
